import { render, staticRenderFns } from "./restrictionStrategyGroup.vue?vue&type=template&id=93c9ef06"
import script from "./restrictionStrategyGroup.vue?vue&type=script&lang=js"
export * from "./restrictionStrategyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports